import { AccountChat } from "./accountChatsParser"

const TRANSCHAT_ROOM_LOCAL_SUFFIX = "_transchat"
const CONFERENCE_DOMAIN_PREFIX = "conference."

const splitJid = (
  jid: string,
): { local: string | undefined; domain: string | undefined } => {
  const [local, domain] = jid.toLowerCase().split("@")
  return { local, domain }
}

export const isTranschatRoomJid = (chatJid: string): boolean => {
  const { local, domain } = splitJid(chatJid)

  return Boolean(
    local &&
      domain &&
      local.endsWith(TRANSCHAT_ROOM_LOCAL_SUFFIX) &&
      domain.startsWith(CONFERENCE_DOMAIN_PREFIX),
  )
}

export const isSlickshiftUser = (jidLocal?: string | null): boolean => {
  return jidLocal?.toLowerCase() === "slickshift"
}

export const findTranschatUserChat = (
  userChats: Record<string, AccountChat>,
  jidLocal?: string,
): AccountChat | undefined => {
  const transchatChats = Object.values(userChats).filter((chat) =>
    isTranschatRoomJid(chat.jid),
  )

  if (!jidLocal) {
    return transchatChats[0]
  }

  const ownTranschatLocal = `${jidLocal.toLowerCase()}${TRANSCHAT_ROOM_LOCAL_SUFFIX}`
  const ownTranschatChat = transchatChats.find((chat) => {
    const { local } = splitJid(chat.jid)
    return local === ownTranschatLocal
  })

  return ownTranschatChat || transchatChats[0]
}

export const shouldHideTranschatChat = (params: {
  privateAgentEnabled: boolean
  isSlickshiftUser: boolean
  chatJid: string
  ownTranschatJid?: string
}): boolean => {
  const { privateAgentEnabled, isSlickshiftUser, chatJid, ownTranschatJid } =
    params

  if (!privateAgentEnabled || !isTranschatRoomJid(chatJid)) {
    return false
  }

  if (!isSlickshiftUser) {
    return true
  }

  return Boolean(ownTranschatJid && chatJid === ownTranschatJid)
}

const getTranschatPrefix = (chatJid: string): string | undefined => {
  const { local } = splitJid(chatJid)
  if (!local || !local.endsWith(TRANSCHAT_ROOM_LOCAL_SUFFIX)) {
    return undefined
  }

  return local
    .slice(0, -TRANSCHAT_ROOM_LOCAL_SUFFIX.length)
    .replace(/[-_.]+$/, "")
}

const getAgentNameFromTranschatJid = (chatJid: string): string | undefined => {
  const prefix = getTranschatPrefix(chatJid)
  if (prefix === undefined) return undefined
  if (!prefix) return "Agent"

  return `Agent - ${prefix}`
}

export const getChatDisplayName = (params: {
  chatName: string
  chatJid: string
  isSlickshiftUser: boolean
}): string => {
  const { chatName, chatJid, isSlickshiftUser } = params
  if (!isSlickshiftUser || !isTranschatRoomJid(chatJid)) {
    return chatName
  }

  return getAgentNameFromTranschatJid(chatJid) || chatName
}
